import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="app-footer" className="mt-20 border-t border-stone-200 bg-secondary/40">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-muted-foreground">
                <div className="flex items-center gap-1.5">
                    Made with <Heart size={12} className="text-accent" fill="currentColor" /> for local
                </div>
                <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-semibold uppercase tracking-[0.15em]">
                    <Link to="/help" data-testid="footer-help" className="hover:text-primary">Help</Link>
                    <Link to="/privacy" data-testid="footer-privacy" className="hover:text-primary">Privacy</Link>
                    <Link to="/terms" data-testid="footer-terms" className="hover:text-primary">Terms</Link>
                    <Link to="/community-guidelines" data-testid="footer-guidelines" className="hover:text-primary">Community</Link>
                    <a href="mailto:contact@fromhere.global" data-testid="footer-contact" className="hover:text-primary">Contact</a>
                </nav>
            </div>
        </footer>
    );
}
